import { Context } from "react"
import OptimizeExperiments from "connected-components/optimize-experiments"
import type { ModelMetadata } from "connected-components/optimize-experiments/types"
import type { OptimizeExperimentsContext } from "connected-components/optimize-experiments/types"

import "./styles.scss"

interface OptimizeExperimentsPanelProps {
  context: Context<OptimizeExperimentsContext>
  modelMetadata: ModelMetadata
  isOptimizedExperimentsEnabled: boolean
}

export default function OptimizeExperimentsPanel({
  context,
  modelMetadata,
  isOptimizedExperimentsEnabled,
}: OptimizeExperimentsPanelProps) {
  if (!isOptimizedExperimentsEnabled) {
    return null
  }

  return (
    <div className="optimizer-widget-panel visible">
      <OptimizeExperiments
        context={context}
        modelMetadata={modelMetadata}
      />
    </div>
  )
}
